import React, { useState } from 'react';
import './Login.css';
import logo from '../assets/Zenio+Logo+header.png';
import { api, useLocalStorageFallback } from '../services/api';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Fallback to localStorage if API not configured
  const useFallback = useLocalStorageFallback();

  const handleSubmitAPI = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await api.login(username, password);
      
      if (result.success && result.user) {
        onLogin(result.user);
      } else {
        setError(result.message || 'Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please check your credentials and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitLocalStorage = (e) => {
    e.preventDefault();
    setError('');

    // Load users from localStorage
    const savedUsers = localStorage.getItem('zenio_users');
    let users = [];
    
    if (savedUsers) {
      users = JSON.parse(savedUsers);
    } else {
      // Initialize with default users
      users = [
        { id: 1, username: 'admin', password: 'admin123', isAdmin: true, name: 'Admin User' },
        { id: 2, username: 'user', password: 'user123', isAdmin: false, name: 'Regular User' },
        { id: 3, username: 'manager', password: 'manager123', isAdmin: true, name: 'Manager' }
      ];
      localStorage.setItem('zenio_users', JSON.stringify(users));
    }

    const user = users.find(
      u => u.username === username && u.password === password
    );

    if (user) {
      const { password, ...userWithoutPassword } = user;
      onLogin(userWithoutPassword);
    } else {
      setError('Invalid username or password');
    }
  };

  const handleSubmit = useFallback ? handleSubmitLocalStorage : handleSubmitAPI;

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-container">
          <div className="logo-backdrop">
            <img src={logo} alt="ZenIO Logo" className="company-logo-img" />
          </div>
          <h2>Company Panel</h2>
        </div>
        
        {useFallback && (
          <div style={{
            background: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '4px',
            padding: '10px',
            marginBottom: '15px',
            fontSize: '13px',
            color: '#856404'
          }}>
            <strong>⚠️ Using LocalStorage Mode</strong>
            <br />
            API not configured. Update API_BASE_URL in src/services/api.js
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
